import { render } from "./InsuranceSummary.vue?vue&type=template&id=425d9072&scoped=true"
import script from "./InsuranceSummary.vue?vue&type=script&lang=js"
export * from "./InsuranceSummary.vue?vue&type=script&lang=js"

import "./InsuranceSummary.vue?vue&type=style&index=0&id=425d9072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425d9072"]])

export default __exports__